import React from 'react';
import Rating from '../rating/rating';
import './user-ranking.scss';

const RankingUser = ({starSummary}) => {
    if (!starSummary || starSummary.size === 0) {
        return null;
    }

    let counter = 0;

    return (
        <ul className="header-stars">
            {starSummary.toArray().map((value, index) => {
                counter++;
                return (
                    <li key={index}>
                        {i18n.t(`reviews.gigs._rating.q${counter}`)}
                        <Rating ratingFive={value/2}/>
                    </li>
                );
            })}
        </ul>
    );
};

export default RankingUser;



// WEBPACK FOOTER //
// ./src/reviews/user_ranking/RankingUser.js